/**
 * A simple memoization helper for class getters.
 * This is often a bad idea, because when you cache a value,
 * you also have to invalidate it when the dependencies change.
 * However, when working with React and effectively immutable data,
 * this is sometimes a non-issue.
 * Use with caution.
 *
 * */
export default function memoizeGetter(klass, functionName) {
  const getter = Object.getOwnPropertyDescriptor(klass.prototype, functionName);
  const cacheKey = `_${functionName}-cache_`;
  Object.defineProperty(klass.prototype, functionName, {
    get() {
      if (cacheKey in this) {
        return this[cacheKey];
      }
      this[cacheKey] = getter.get.call(this);
      return this[cacheKey];
    },
  });
}
